import { c as _c } from "react/compiler-runtime";
import { FormSelect, FormSelectMultiple, RadioGroup } from '@systemeio/ui';
import { OpenInNewIcon } from '@systemeio/ui/icons';
import EditActionWrapper from 'modules/automation-rules/actions/components/edit-actions/components/edit-action-wrapper';
import { EditActionItemInterface } from 'modules/automation-rules/actions/components/edit-actions/types/edit-action-item-interface';
import { ActionCourseEditInterface } from 'modules/automation-rules/actions/types/automation-rule-actions-edit-interface';
import { getDataFromObj } from 'modules/automation-rules/utils/get-filter-data';
import { useCourseCurriculum } from 'modules/courses/courses/curriculum/hooks/use-cource-curriculum';
import { getCourseAccessTypeDataOptions } from 'modules/courses/courses/curriculum/utils/get-course-access-type-data-options';
import { isPartialType } from 'modules/courses/courses/curriculum/utils/is-partial-type';
import { getCourseCurriculumUrl } from 'modules/courses/courses/utils/get-course-curriculum-url';
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { AutomationRuleActionsEnum } from '../../../enums/action-enum';
import { isCoursePartialAccessAction } from '../../../utils/is-course-partial-access-action';
interface ActionCourseItemProps extends EditActionItemInterface<ActionCourseEditInterface> {}
const ActionCourseItem = t0 => {
  const $ = _c(22);
  const {
    action,
    errors,
    setRules,
    onDelete,
    idx
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const isEnrollInCourse = action.type === AutomationRuleActionsEnum.enroll_in_course;
  const {
    data: courseCurriculumData
  } = useCourseCurriculum(isEnrollInCourse && isPartialType(action.accessType) ? action.course.id : undefined);
  let t1;
  if ($[0] !== courseCurriculumData?.modules) {
    t1 = courseCurriculumData?.modules.map(_temp);
    $[0] = courseCurriculumData?.modules;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const courseModulesData = t1;
  let t2;
  if ($[2] !== idx || $[3] !== setRules) {
    t2 = () => {
      setRules(prev => ({
        ...prev,
        actions: prev.actions.map((el, i) => {
          if (idx === i) {
            if (el.type !== AutomationRuleActionsEnum.enroll_in_course) {
              return el;
            }
            if (isCoursePartialAccessAction(el)) {
              const {
                courseModules,
                ...rest
              } = el;
              return {
                ...rest,
                courseModules: []
              };
            } else {
              const {
                courseModules: courseModules_0,
                ...rest_0
              } = el;
              return rest_0;
            }
          } else {
            return el;
          }
        })
      }));
    };
    $[2] = idx;
    $[3] = setRules;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const cleanUpCourseModules = t2;
  let t3;
  if ($[5] !== idx || $[6] !== onDelete) {
    t3 = () => onDelete(idx);
    $[5] = idx;
    $[6] = onDelete;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== action || $[9] !== cleanUpCourseModules || $[10] !== courseCurriculumData?.modules || $[11] !== courseModulesData || $[12] !== errors.automationActions || $[13] !== idx || $[14] !== isEnrollInCourse || $[15] !== setRules || $[16] !== t) {
    t4 = t5 => {
      const {
        data,
        onOpen,
        renderActionLabel
      } = t5;
      return <><FormSelect onOpen={onOpen} label={renderActionLabel({
          label: t("dashboard.courses.title"),
          additionalLabel: action.course.id ? <LinkWithoutPrefetch href={getCourseCurriculumUrl({
            courseId: action.course.id
          })} rel="noreferrer" target="_blank" className="group self-center outline-hidden"><OpenInNewIcon className="main-transition-colors group-focus-visible:fill-brand-primary hover:fill-brand-primary" /></LinkWithoutPrefetch> : undefined
        })} placeholder={t("dashboard.automation_rule.choose_course")} value={action.course.id} data={data.courseData} staticData={getDataFromObj(action.course)} onChange={data_0 => {
          setRules(prev_0 => ({
            ...prev_0,
            actions: prev_0.actions.map((el_0, i_0) => {
              if (idx === i_0) {
                return {
                  ...el_0,
                  course: {
                    id: data_0
                  }
                };
              } else {
                return el_0;
              }
            })
          }));
          cleanUpCourseModules();
        }} error={errors.automationActions[action.id]?.course?.join("")} />{isEnrollInCourse && <><RadioGroup options={getCourseAccessTypeDataOptions(t)} selected={action.accessType} onChange={data_1 => {
            setRules(prev_1 => ({
              ...prev_1,
              actions: prev_1.actions.map((el_1, i_1) => {
                if (idx === i_1) {
                  return {
                    ...el_1,
                    accessType: data_1
                  };
                } else {
                  return el_1;
                }
              })
            }));
            cleanUpCourseModules();
          }} error={errors.automationActions[action.id]?.courseAccessType?.flat().join("")} />{isCoursePartialAccessAction(action) && action.course.id && <FormSelectMultiple required={true} label={t("dashboard.course.module_title")} placeholder={t("dashboard.automation_rule.trigger.choose_module")} data={courseModulesData} value={action.courseModules.map(_temp2)} withoutCloseIcon={!action.courseModules?.length} onChange={data_2 => setRules(prev_2 => ({
            ...prev_2,
            actions: prev_2.actions.map((el_2, i_2) => {
              if (idx === i_2 && el_2.type === AutomationRuleActionsEnum.enroll_in_course && isCoursePartialAccessAction(el_2)) {
                return {
                  ...el_2,
                  courseModules: courseCurriculumData?.modules?.filter(t6 => {
                    const {
                      id: id_1
                    } = t6;
                    return data_2.includes(id_1);
                  }) ?? []
                };
              } else {
                return el_2;
              }
            })
          }))} error={errors.automationActions[action.id]?.courseModules?.flat().join("")} />}</>}</>;
    };
    $[8] = action;
    $[9] = cleanUpCourseModules;
    $[10] = courseCurriculumData?.modules;
    $[11] = courseModulesData;
    $[12] = errors.automationActions;
    $[13] = idx;
    $[14] = isEnrollInCourse;
    $[15] = setRules;
    $[16] = t;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  if ($[18] !== action.type || $[19] !== t3 || $[20] !== t4) {
    t5 = <EditActionWrapper slug={action.type} onDelete={t3}>{t4}</EditActionWrapper>;
    $[18] = action.type;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  return t5;
};
export default ActionCourseItem;
function _temp(t0) {
  const {
    id,
    name
  } = t0;
  return {
    id,
    caption: name
  };
}
function _temp2(t0) {
  const {
    id: id_0
  } = t0;
  return id_0;
}